import React from 'react';
import * as S from './AccordBtn.styles';

interface IButton {
  btnWidth?: string;
  btnHeight?: string;
  margin?: string
  active?: boolean;
};

const Button: React.FC<IButton> = (props) => (
  <S.AccordBtn {...props} />
);

export default Button;